import { runResolutionBody, startResolution, } from './resolution.js';
/**
 * Прогнать СИНТЕТИЧЕСКУЮ эмиссию события через хуки реестра (tech-шов M3a; в M4
 * его место займёт Action-уровневый apply). Верхнеуровневое событие применяется
 * reducer'ом и кладётся в очередь; затем ВОЗОБНОВЛЯЕМЫЙ дренаж вызывает хуки карт
 * (в т.ч. генераторы choose — тогда результат status:'awaiting_choice', R2).
 */
export function dispatchSyntheticEvent(registry, state, event) {
    return startResolution(registry, state, event);
}
/**
 * ТЕСТ-ХЕЛПЕР: построить CardContext для носителя (self/effect) и выполнить
 * `body` как тело хука; затем дренаж (с диспетчеризацией из registry, по
 * умолчанию — пустой). Возвращает ResolutionResult. Удобно для белого ящика:
 * q-проекции, rng-детерминизм, setVar, авто-sourceId (обе ветви D31).
 */
export function runCardHook(state, subject, body, registry = new Map()) {
    return runResolutionBody(registry, state, subject, body);
}
//# sourceMappingURL=dispatch.js.map